import styled, { css } from 'styled-components';
import { minBp, maxBp } from 'src/lib/theme';
import _TriumphTriangle from 'src/assets/icons/triumph-triangle.svg';
import Button from 'components/Button/Button';

export const Card = styled.div`
  ${({ horizontalScroll }) => `
    display: flex;
    flex-direction: column;
    cursor: pointer;
    position: relative;
    min-width: 0;
    background-color: white;
    animation-name: fadeIn;
    animation-duration: 0.75s;
    animation-fill-mode: forwards;
    will-change: opacity;
    opacity: 0;

    ${
      horizontalScroll
        ? `
      @media ${maxBp('desktop')} {
        width: 126px;
      }
    `
        : ``
    }

    @keyframes fadeIn {
      from {
        opacity: 0;
      }

      to {
        opacity: 1;
      }
    }

    @media screen and (-ms-high-contrast: active), screen and (-ms-high-contrast: none) {
      width: calc(50% - 16px);
      margin-right: 16px;

      &:nth-of-type(even) {
        &:nth-last-child(-n+2) {
          margin-bottom: 16px;
        }
      }

      &:nth-of-type(odd) {
        &:nth-last-child(-n+1) {
          margin-bottom: 0px;
        }
        &:nth-last-child(-n+3) {
          margin-bottom: 16px;
        }
      }

      &:nth-last-child(n + 3) {
        margin-bottom: 16px;
      }
    }
  `}
`;

export const ImageWrap = styled.div`
  flex: 1;
  border-bottom: 1px solid #e0e0e0;
  overflow: hidden;
  height: 0;
  padding-top: 57.14%;
  position: relative;
`;

export const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
  position: absolute;
  top: 0;
  left: 0;
  opacity: ${({ loaded }) => (loaded ? '1' : '0')};
  transition: opacity 0.2s ease-in;

  @media screen and (-ms-high-contrast: active), screen and (-ms-high-contrast: none) {
    background-color: purple;
    margin-top: 0 !important;
    top: 50% !important;
    left: 50% !important;
    width: auto !important;
    height: 100% !important;
    transform: translate(-50%, -50%) !important;
    transition: none;
  }
`;

export const NotVisible = styled.div`
  position: absolute;
  top: 4px;
  left: 9px;
  width: 16px;

  svg {
    width: 16px;
  }

  @media ${minBp('tabletLarge')} {
    pointer-events: none;
  }
`;

export const InfoWrap = styled.div`
  height: 80px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 9px;
  position: relative;
`;

export const Info = styled.div``;

export const Name = styled.div`
  font-family: ${({ theme }) => theme.fonts.dinDemi};
  text-transform: uppercase;
  font-size: 12px;
  color: #000;
  line-height: 1;
  margin-bottom: 5px;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

export const PartNumberStyles = css`
  display: block;
  font-size: 8px;
  color: #000;
  margin-left: 5px;
  text-transform: uppercase;

  @media ${minBp('desktop')} {
    font-size: 10px;
  }
`;

export const PartNumberWrap = styled.div`
  ${PartNumberStyles}
  display: flex;
  margin-left: 0;
`;

export const PartNumber = styled.span`
  ${PartNumberStyles}
`;

export const TotalWrap = styled.div`
  display: flex;
  align-items: center;

  svg {
    vertical-align: middle;
    height: 10px;
    width: 10px;
    margin-right: 2px;

    path {
      fill: #2a2a2a;
    }
  }
`;

export const TotalStyles = css`
  font-size: 10px;
  padding-right: 7px;
  border-right: 1px solid #b7b7b7;
`;

export const Price = styled.span`
  ${TotalStyles}
  margin-right: 7px;
  line-height: 1;
`;

export const Fitting = styled.span`
  ${TotalStyles}
  padding-right: 0;
  border-right: 0;
`;

export const Triangle = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 0 40px 40px 0;
  border-color: transparent #000000 transparent transparent;
`;

export const AddIconWrap = styled.div`
  position: absolute;
  top: 2px;
  right: 2px;

  svg {
    width: 14px;
    height: 14px;
    position: absolute;
    top: 5px;
    right: 6px;
  }
`;

export const SelectedIndicator = styled.div`
  position: absolute;
  top: 0;
  right: 0;

  svg {
    width: 14px;
    height: 14px;
    position: absolute;
    top: 5px;
    right: 6px;

    path {
      fill: white;
    }
  }
`;

export const InfoCircleWrap = styled.div`
  cursor: pointer;
  padding-bottom: 2px;

  svg {
    pointer-events: none;
    width: 15px;
    height: 15px;
    vertical-align: middle;
    filter: invert(100%) sepia(100%) saturate(0%) hue-rotate(162deg);

    & > path {
      fill: black;
    }
  }

  &:hover,
  &:focus {
    & > svg > path {
      fill: background: #505050;
    }
  }
`;

export const TriumphTriangle = styled(_TriumphTriangle)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 50px;
  height: 50px;
`;

export const DetailsButton = styled(Button)`
  background-color: ${({ theme }) => theme.colors.buttons.default};
  color: white;
  font-family: ${({ theme }) => theme.fonts.dinDemi};
  font-weight: 500;
  text-transform: uppercase;
  text-decoration: none;
  font-size: 12px;
  padding: 4px;
  width: auto;
  height: 24px;
  margin: 0px 8px 8px 8px;
  display: flex;
  align-items: center;
  gap: 5px;
  flex-wrap: nowrap;

  @media ${minBp('tablet')} {
    font-size: 12px;
  }

  @media ${minBp('desktop')} {
    margin: 0px;
  }

  span {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;
